import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { reactive, ref, toRefs } from "vue";
//@ts-ignore
import { updatePhoneView } from "@services/statisticsAPI";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { getOrNull } from "@utils/ObjectUtils";
//@ts-ignore
import { UserTypologyId } from "@customTypes/UserTypologyId";
//@ts-ignore
import { usePublicUserMenuStore } from "@wkWebSrc/js/store";
//@ts-ignore
import { hashEmail } from "@utils/EmailUtils";
export function getPhoneLabelElements(agencyId) {
  return document.querySelectorAll("[data-id='phone-".concat(agencyId, "']"));
}
function isPhoneLabelShown(phoneLabelElements) {
  for (var el of phoneLabelElements) {
    if (el.getAttribute("data-active")) return true;
  }
  return false;
}
export function showPhoneLabel(phoneLabelElements, displayPhone) {
  phoneLabelElements.forEach(el => {
    el.innerHTML = displayPhone;
    el.setAttribute("data-active", "true");
  });
}
function setGaEventSent(agencyId) {
  var _a;
  (_a = document.querySelector("[data-agency-id='".concat(agencyId, "']"))) === null || _a === void 0 ? void 0 : _a.setAttribute("data-ga", "true");
}
export function hasGaEventSent(agencyId) {
  var _a;
  return !!((_a = document.querySelector("[data-agency-id='".concat(agencyId, "']"))) === null || _a === void 0 ? void 0 : _a.getAttribute("data-ga"));
}
export function useShowPhone() {
  var _this = this;
  var state = reactive({
    phoneViewId: 0,
    displayPhone: "",
    phoneLabel: ""
  });
  var phoneSpanElements = ref();
  var pum = usePublicUserMenuStore();
  var {
    isSmall
  } = useBreakpoints();
  var handlePhoneViewUpdating = (agencyData, location) => __awaiter(this, void 0, void 0, function* () {
    var _a;
    try {
      var price;
      if (agencyData.id) price = parseFloat(((_a = agencyData.price) === null || _a === void 0 ? void 0 : _a.replace(".", "")) || "0");
      //If we sent a GA event for a given agency, we won't send it again!
      if (hasGaEventSent(agencyData.agencyId)) return;
      var user_id = pum.publicUserId === -1 ? null : pum.publicUserId;
      var user_email_hashed = pum.email ? yield hashEmail(pum.email) : null;
      if (agencyData === null || agencyData === void 0 ? void 0 : agencyData.auction) {
        var payload = {
          event_location: location,
          real_estate_contract_type: "auction",
          real_estate_id: getOrNull(agencyData.id),
          real_estate_place_id: getOrNull(agencyData.placeID),
          real_estate_typology_name: getOrNull(agencyData.typologyName)
        };
        if (agencyData.userTypologyId == UserTypologyId.AUCTION_CONSULTANT) {
          sendGAEvent("auction_consultant_phone_show", {
            auction_consultant_id: agencyData.agencyId,
            auction_consultant_name: getOrNull(agencyData.agencyName),
            event_location: payload.event_location,
            real_estate_contract_type: payload.real_estate_contract_type,
            real_estate_id: payload.real_estate_id,
            real_estate_place_id: payload.real_estate_place_id,
            real_estate_typology_name: payload.real_estate_typology_name,
            user_id,
            user_email_hashed
          });
        } else if (agencyData.userTypologyId == UserTypologyId.AUCTION_GUARDINA) {
          sendGAEvent("auction_guardian_phone_show", {
            auction_guardian_id: agencyData.agencyId,
            auction_guardian_name: getOrNull(agencyData.agencyName),
            event_location: payload.event_location,
            real_estate_contract_type: payload.real_estate_contract_type,
            real_estate_id: payload.real_estate_id,
            real_estate_place_id: payload.real_estate_place_id,
            real_estate_typology_name: payload.real_estate_typology_name,
            user_id,
            user_email_hashed
          });
        } else {
          sendGAEvent("auction_supervisor_phone_show", {
            auction_supervisor_id: agencyData.agencyId,
            auction_supervisor_name: getOrNull(agencyData.agencyName),
            event_location: payload.event_location,
            real_estate_contract_type: payload.real_estate_contract_type,
            real_estate_id: payload.real_estate_id,
            real_estate_place_id: payload.real_estate_place_id,
            real_estate_typology_name: payload.real_estate_typology_name,
            user_id,
            user_email_hashed
          });
        }
      } else {
        sendGAEvent("phone_show", {
          event_location: location,
          agency_id: agencyData.agencyId,
          agency_name: agencyData.agencyName,
          agency_place_id: null,
          agency_subscription_type: agencyData.premium ? "premium" : agencyData.lite ? "lite" : "free",
          agency_franchise_id: getOrNull(agencyData.franchiseId),
          agency_franchise_name: getOrNull(agencyData.franchiseName),
          product_price: getOrNull(price),
          real_estate_id: getOrNull(agencyData.id),
          real_estate_contract_type: agencyData.rent ? "rent" : "sale",
          real_estate_place_id: getOrNull(agencyData.placeID),
          real_estate_typology_name: agencyData.typologyName,
          user_id,
          user_email_hashed
        });
      }
      setGaEventSent(agencyData.agencyId);
      //sending internal statistics data
      yield updatePhoneView(agencyData.agencyId, agencyData.id);
    } catch (err) {
      console.error(err);
    }
  });
  var showPhone = function showPhone(agencyData, location) {
    var phone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var immPopup = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return __awaiter(_this, void 0, void 0, function* () {
      var _b;
      phoneSpanElements.value = getPhoneLabelElements(agencyData.agencyId);
      if (phoneSpanElements.value.length === 0) throw "There is no span with the following id: phone-".concat(agencyData.agencyId);
      if (isSmall.value || isPhoneLabelShown(phoneSpanElements.value) || immPopup) {
        window.location.href = (_b = "tel:".concat(phone)) !== null && _b !== void 0 ? _b : "#";
      }
      if (phone) state.displayPhone = phone;
      var id = agencyData.id ? agencyData.id : agencyData.agencyId;
      if (!immPopup) showPhoneLabel(phoneSpanElements.value, state.displayPhone);
      //If the event has been already sent
      if (state.phoneViewId && state.phoneViewId === id) return;
      yield handlePhoneViewUpdating(agencyData, location);
      state.phoneViewId = id;
    });
  };
  return Object.assign(Object.assign({}, toRefs(state)), {
    showPhone
  });
}